export default () => {
  let timeouts = {};

  // check for when article rows are visible
  const articleObserver = new IntersectionObserver(
    (entries, observer) => {
      // using setTimeout to ignore the affect when jump links are clicked
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          timeouts[entry.target.dataset.id] = window.setTimeout(() => {
            entry.target.classList.add("scrolled-into-view");
            // only runs once to prevent the component from jittering as hidden articles shrink.
            observer.unobserve(entry.target);
          }, 300);
        } else {
          window.clearTimeout(timeouts[entry.target.dataset.id]);
        }
      });
    },
    {
      root: null,
      rootMargin: "-40% 0px -20%",
      threshold: 0.5,
    },
  );

  document
    .querySelectorAll(".js-interactive-timeline")
    .forEach((parentEl, parentIndex) => {
      // flag articles that are in view.
      parentEl
        .querySelectorAll(".js-interactive-timeline-article")
        .forEach((el, i) => {
          el.dataset.id = `article-${parentIndex}-${i}`;
          articleObserver.observe(el);
        });

      // assumption is that the length here matches the number of rows
      const timelineMarkers = parentEl.querySelectorAll(
        ".js-timeline-year-marker",
      );
      const yearRows = parentEl.querySelectorAll(
        ".js-interactive-timeline-year",
      );

      if (timelineMarkers.length !== yearRows.length) {
        console.warn("year rows don't match progress bar");
        return;
      }

      timelineMarkers.forEach((marker, i) => {
        marker.href = marker.dataset.href; // working around inPageNavigation JS;
        marker.addEventListener("click", (e) => {
          e.preventDefault();
          scrolToRow(yearRows[i]);
        });
      });

      // check for when years are visible
      const yearObserver = new IntersectionObserver(
        (entries, observer) => {
          // using setTimeout to ignore the affect when jump links are clicked
          entries.forEach((entry) => {
            const index = parseInt(entry.target.dataset.index, 10);

            if (entry.isIntersecting) {
              entry.target.classList.add("scrolled-into-view");
              timelineMarkers[index].classList.add("is-active");
              timelineMarkers[index].setAttribute("aria-current", "location");
            } else {
              entry.target.classList.remove("scrolled-into-view");
              timelineMarkers[index].classList.remove("is-active");
              timelineMarkers[index].removeAttribute("aria-current");
            }
          });
        },
        {
          root: null,
          rootMargin: "-47% 0px -47%", //"px" - units required
          threshold: 0,
        },
      );

      // Flag rows that are in view and update the progress bar
      yearRows.forEach((el, i) => {
        el.dataset.index = i;
        yearObserver.observe(el);
      });
    });
};

function scrolToRow(rowEl) {
  const { top } = rowEl.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  const viewportOffset = windowHeight * 0.41; // close to the threshold
  const offset = top + document.documentElement.scrollTop - viewportOffset;

  let focusTimeout = setTimeout(() => {}, 10);

  rowEl
    .querySelectorAll(".js-interactive-timeline-article")[0]
    .classList.add("scrolled-into-view");

  const moveFocus = () => {
    window.clearTimeout(focusTimeout);
    focusTimeout = setTimeout(() => {
      rowEl.focus();
      // prevent focus jump
      window.scrollTo(0, offset);
      window.removeEventListener("scroll", moveFocus);
    }, 100);
  };

  // move the focus when the page finishes scrolling
  window.addEventListener("scroll", moveFocus);

  window.scroll({
    top: offset,
    left: 0,
    behavior: "smooth",
  });
}
